<template>
	<div
		class="section"
		:class="{ 'section--open': expanded }">
		<button
			class="section__header"
			@click="expanded = !expanded">
			<div class="section__header-left">
				<div class="section__icon-container">
					<FontAwesomeIcon :icon />
				</div>
				<div class="section__title-container">
					<span class="section__title">{{ title }}</span>
					<span class="section__total"
						>{{ time.hours }}h {{ time.minutes }}m using manual labor</span
					>
				</div>
			</div>
			<div class="section__header-right">
				<FontAwesomeIcon
					class="section__chevron"
					icon="fas fa-chevron-right" />
			</div>
		</button>
		<div class="section__content">
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue'

defineProps<{
	icon: string
	title: string
	time: { hours: number; minutes: number }
	value: string
}>()

const expanded = ref(false)
</script>

<style lang="scss" scoped>
.section {
	background: var(--card-bg);
	border-radius: 10px;
	overflow: hidden;

	.section__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px;
		background: transparent;
		border: none;
		cursor: pointer;
		width: 100%;
		border: solid 1px var(--p-stone-800);
		border-radius: 8px;

		.section__header-left {
			display: flex;
			align-items: center;
			gap: 8px;

			.section__icon-container {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 30px;
				height: 30px;
				border-radius: 8px;
				background: rgba(238, 255, 1, 0.1);

				i {
					color: var(--p-yellow-500);
				}
			}

			.section__title-container {
				display: flex;
				align-items: start;
				flex-direction: column;
				gap: 2px;

				.section__title {
					font-size: 16px;
					font-weight: 600;
					letter-spacing: 0.2px;
				}

				.section__total {
					font-size: 12px;
					color: var(--muted);
					font-weight: 400;
				}
			}
		}

		.section__header-right {
			display: flex;
			align-items: center;
			gap: 10px;
		}

		.section__chevron {
			transition: transform 0.1s;
		}
	}

	.section__content {
		display: none;
		padding: 0 16px 0 44px;
		position: relative;

		&::before {
			content: '';
			position: absolute;
			left: 24px;
			top: 8px;
			bottom: 8px;
			width: 2px;
			background: var(--border);
			border-radius: 2px;
		}
	}

	&--open {
		.section__chevron {
			transform: rotate(90deg);
		}

		.section__content {
			display: block;
		}
	}
}
</style>
